import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { ChartTooltipContent } from '@/components/application/charts/charts-base'
import { cx } from '@/utils/cx'

/**
 * Ein Balkendiagramm nach dem Muster der Untitled-UI-Charts (`charts-base`,
 * Recharts darunter). Farbe über `currentColor`, damit Tailwind-Tokens sie
 * setzen — kein Inline-Stil, keine Hex-Zahl im Code.
 *
 * Recharts ist eine Abhängigkeit **dieses** Pakets, nicht der Anwendungen:
 * Wer ein Diagramm braucht, holt es hier, wie jeden anderen Baustein.
 */
export interface Balkenwert {
  name: string
  anzahl: number
}

export interface BalkendiagrammProps {
  daten: readonly Balkenwert[]
  /** Tailwind-Textfarbe, färbt die Balken — Vorgabe Markenfarbe. */
  farbe?: string
  /** Nur jede n-te Beschriftung an der X-Achse — bei 24 Stunden jede dritte. */
  beschriftungJede?: number
  /** Was ein Balken zählt — steht im Tooltip. */
  einheit?: string
  className?: string
}

export function Balkendiagramm({
  daten,
  farbe = 'text-utility-brand-600',
  beschriftungJede = 1,
  einheit = 'Anrufe',
  className,
}: BalkendiagrammProps) {
  return (
    <div className={cx('h-56 w-full', farbe, className)}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={[...daten]} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
          <CartesianGrid
            vertical={false}
            stroke="currentColor"
            className="text-utility-neutral-100"
          />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            interval={beschriftungJede - 1}
            tick={{ fill: 'var(--color-text-quaternary)', fontSize: 12 }}
            className="text-quaternary"
          />
          <YAxis
            allowDecimals={false}
            axisLine={false}
            tickLine={false}
            tick={{ fill: 'var(--color-text-quaternary)', fontSize: 12 }}
            className="text-quaternary"
          />
          <Tooltip
            cursor={{ fill: 'currentColor', className: 'text-utility-neutral-100' }}
            content={<ChartTooltipContent />}
          />
          <Bar dataKey="anzahl" name={einheit} fill="currentColor" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
